import { FC } from 'react';
import { MinusOutlined } from '@ant-design/icons';

import { AdditionalOption } from '../../api/contracts';
import {
	AdditionalFeatureContainerStyled,
	AdditionalFeatureNameStyled,
	AdditionalFeaturePriceStyled,
} from './AdditionalPlanFeaturesListItem.styles';

interface AdditionalPlanFeaturesListItemProps {
	feature: AdditionalOption;
}

export const AdditionalPlanFeaturesListItem: FC<AdditionalPlanFeaturesListItemProps> = ({ feature }) => (
	<AdditionalFeatureContainerStyled>
		<MinusOutlined />
		<AdditionalFeatureNameStyled>{feature.name}</AdditionalFeatureNameStyled>
		{feature.price && (
			<AdditionalFeaturePriceStyled>{`+ ${feature.price} ₽ за заведение`}</AdditionalFeaturePriceStyled>
		)}
	</AdditionalFeatureContainerStyled>
);
